import * as React from "react";
import { CircleTableTop, SquareTableTop, WoodenTableTop } from "../../components";
import { ITables } from "../../all-types";
import { useTableByIdLive } from "../../realtime";
import { useAppDispatch } from "../../redux-store/hooks";
import { updateTable } from "../../redux-store";

const tableMap: Record<
    string,
    React.ComponentType<ITables>
> = {
    CIRCULAR: CircleTableTop,
    SQUARE: SquareTableTop,
    RECTANGULAR: WoodenTableTop,
};

const Fallback: React.FC = () => <div>Invalid table configuration</div>;

const BillCounterTable: React.FC<ITables> = ({
    tableType,
    capacity,
    tableNo,
    tableColor,
    ...rest
}) => {
    const Component = tableMap[tableType] ?? Fallback;
    const dispatcher = useAppDispatch();
    useTableByIdLive(rest._id, (t) => dispatcher(updateTable(t)));

    if (Component === Fallback) return <Fallback />;

    return <Component
        tableNo={tableNo}
        tableType={"CIRCULAR"}
        capacity={capacity}
        tableColor={tableColor}
        {...rest}
        />;
};

export { BillCounterTable };
